import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_toaster = _resolveComponent("app-toaster")!
  const _component_app_dialog = _resolveComponent("app-dialog")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_toaster),
    _createVNode(_component_app_dialog),
    _createVNode(_component_router_view)
  ], 64))
}